





















































import Vue, { VueConstructor } from "vue";
import { mapState } from "vuex";
import { Record } from "@/common/api/leaderboard/Record";
import { share, embed } from "@/js/social/facebook";
import { sharetwitter } from "@/js/social/twitter";
import { getLaunchState, LaunchState } from "@/game/skifree/util";
import { trackEvent } from "@/js/tracking/gtag";

interface Store {
  currentScore: Record;
}
export default (Vue as VueConstructor & Store).extend({
  props: {
    isInstructions: Boolean
  },
  computed: {
    ...mapState("leaderboard", ["currentScore"])
  },
  methods: {
    onFacebookClick(): void {
      let appID: string = "421316888760433";
      embed(appID, undefined, () => {
        share(window.location.origin, this.shareText(true));
      });
      trackEvent("share", { method: "facebook" });
    },
    onTwitterClick() {
      let hashTag: any = "ExOnTheBeach";
      sharetwitter(
        window.location.origin,
        this.shareText(false),
        "account",
        hashTag
      );
      trackEvent("share", { method: "twitter" });
    },
    shareText(isFacebook: boolean) {
      let isBeforeLaunch = getLaunchState() == LaunchState.BEFORE;
      return gameOverMsg(
        isFacebook,
        this.isInstructions ? 0 : this.currentScore.score,
        this.isInstructions ? "" : this.currentScore.medal,
        isBeforeLaunch
      );
    }
  }
});

function instructionsMsg(isFacebook: boolean, isBeforeLaunch: boolean): string {
  if (isBeforeLaunch) return instructionMsgBefore(isFacebook);
  return instructionMsgAfter(isFacebook);
}

function gameOverMsg(
  isFacebook: boolean,
  score: number,
  medal: string,
  isBeforeLaunch: boolean
): string {
  if (medal === "bronze" && isBeforeLaunch)
    return bronzeMsgBefore(isFacebook, score);
  if (medal === "silver" && isBeforeLaunch)
    return silverMsgBefore(isFacebook, score);
  if (medal === "gold" && isBeforeLaunch)
    return goldMsgBefore(isFacebook, score);
  if (medal === "bronze" && !isBeforeLaunch)
    return bronzeMsgAfter(isFacebook, score);
  if (medal === "silver" && !isBeforeLaunch)
    return silverMsgAfter(isFacebook, score);
  if (medal === "gold" && !isBeforeLaunch)
    return goldMsgAfter(isFacebook, score);
  return instructionsMsg(isFacebook, isBeforeLaunch);
}

//before
function instructionMsgBefore(isFacebook: boolean): string {
  return `Ummm, apparently I’m horrible at avoiding red flags! Check out MTV’s Ski EXscape game and make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(isFacebook)}: Peak of Love December 5th at 9/8c on ${atSymbol(
    isFacebook
  )}MTV`;
}

function bronzeMsgBefore(isFacebook: boolean, score: number): string {
  return `Aggressively trying to avoid my ex at all costs…can you beat my score of ${score}? Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(
    isFacebook
  )}: Peak of Love starting December 5th at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

function silverMsgBefore(isFacebook: boolean, score: number): string {
  return `Avoiding red flags is NOT one of my strengths. Can you beat my score of ${score} on MTV’s Ski EXscape? Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(
    isFacebook
  )}: Peak of Love starting December 5th at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

function goldMsgBefore(isFacebook: boolean, score: number): string {
  return `Amazing! ${atSymbol(
    isFacebook
  )}MTV thinks I’m in a stable relationship with a high score of ${score}. Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(
    isFacebook
  )}: Peak of Love starting December 5th at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

//after
function instructionMsgAfter(isFacebook: boolean): string {
  return `Ummm, apparently I’m horrible at avoiding red flags! Check out MTV’s Ski EXscape game and make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(isFacebook)}: Peak of Love Thursdays at 9/8c on ${atSymbol(
    isFacebook
  )}MTV`;
}

function bronzeMsgAfter(isFacebook: boolean, score: number): string {
  return `Aggressively trying to avoid my ex at all costs…can you beat my score of ${score}? Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(isFacebook)}: Peak of Love Thursdays at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

function silverMsgAfter(isFacebook: boolean, score: number): string {
  return `Avoiding red flags is NOT one of my strengths. Can you beat my score of ${score} on MTV’s Ski EXscape? Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(isFacebook)}: Peak of Love Thursdays at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

function goldMsgAfter(isFacebook: boolean, score: number): string {
  return `Amazing! ${atSymbol(
    isFacebook
  )}MTV thinks I’m in a stable relationship with a high score of ${score}. Make sure to check out ${atSymbol(
    isFacebook
  )}${showTitle(isFacebook)}: Peak of Love Thursdays at 9/8c on ${atSymbol(
    isFacebook
  )}MTV.`;
}

function atSymbol(isFacebook: boolean): string {
  return isFacebook ? "" : "@";
}
function showTitle(isFacebook: boolean): string {
  return isFacebook ? "Ex On The Beach" : "ExOnTheBeach";
}
